export enum AbsenceLimitCalcTypeEnum {
  Base = 1,
  EquivalentHourly = 2
}